import dayjs from 'dayjs';

export interface IDateRangeValidationError {
  title: string;
  text: string;
}

export const handleChangeLocaleTime = (date: string, options: { includeTime?: boolean } = { includeTime: true }) => {
  if (!date) return;

  const tempDate = new Date(`${date}Z`); // UTC 기준

  const year = tempDate.getFullYear();
  const month = String(tempDate.getMonth() + 1).padStart(2, '0');
  const day = String(tempDate.getDate()).padStart(2, '0');
  const hours = String(tempDate.getHours()).padStart(2, '0');
  const minutes = String(tempDate.getMinutes()).padStart(2, '0');
  const seconds = String(tempDate.getSeconds()).padStart(2, '0');

  if (!options.includeTime) {
    return `${year}-${month}-${day}`;
  }

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getLocaleDate = (date: string) => {
  if (!date) return null;

  const tempDate = new Date(`${date}Z`); // UTC 기준

  return tempDate;
};

export const getEndOfDay = (date: Date | null) => {
  if (!date) return null;

  const normalizedDate = new Date(date);
  normalizedDate.setHours(23, 59, 59, 0);

  return normalizedDate;
};

export const getStartOfDay = (date: Date | null) => {
  if (!date) return null;

  const normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);

  return normalizedDate;
};

export const formatDateTimeForApi = (date: Date | null) => {
  if (!date) return null;

  return date.toISOString().substring(0, 19);
};

export const isDateRangeWithinMonths = (startDate: Date | null, endDate: Date | null, maxMonths: number): boolean => {
  if (!startDate || !endDate) {
    return true;
  }

  const maxEndDate = dayjs(startDate).add(maxMonths, 'month').endOf('day');
  return !dayjs(endDate).isAfter(maxEndDate);
};

export const getDateRangeValidationError = (
  startDate: Date | null,
  endDate: Date | null,
  maxMonths = 3,
): IDateRangeValidationError | null => {
  if (!startDate || !endDate) {
    return null;
  }

  if (dayjs(endDate).isBefore(dayjs(startDate), 'day')) {
    return {
      title: '날짜 선택 오류',
      text: '종료일은 시작일보다 빠를 수 없습니다.',
    };
  }

  if (!isDateRangeWithinMonths(startDate, endDate, maxMonths)) {
    return {
      title: '조회 기간 오류',
      text: `조회는 최대 ${maxMonths}개월까지 가능합니다.`,
    };
  }

  return null;
};

export const formatDate = (value?: string | null): string => (value ? (handleChangeLocaleTime(value) ?? '-') : '-');
